module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"continue":"Continue","decorate":"Decorate","fill":"Write a draft","research":"Research","variant":"Variant #{0}"}}')
  delete Component.options._Ctor
}
